export default "__VITE_ASSET__D0yH5q4g__"